export default __webpack_public_path__ + "2e960e57a2582a96b67e587c2c7aade2.svg";